export default function SvgForward() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="40px"
      viewBox="0 -960 960 960"
      width="40px"
      fill="white"
    >
      <path d="M164.97-295.38v-369.24L437.69-480 164.97-295.38Zm357.49 0v-369.24L795.18-480 522.46-295.38Z" />
    </svg>
  );
}
